// extracted by mini-css-extract-plugin
export default {"cls1":"UpoDaEbdXPDexUkZlTqW","cls2":"Ya0frByCBtDKnQGtzKW5 UpoDaEbdXPDexUkZlTqW"};